import { TouchableOpacity } from 'react-native';
import styled from 'styled-components/native';

import { Colors } from 'theme/colors';

const BUTTON_SIZE = 50;

const Button = styled(TouchableOpacity)`
  position: absolute;
  top: 50%;
  background-color: ${Colors.black};
  justify-content: center;
  align-items: center;
  height: ${BUTTON_SIZE}px;
  width: ${BUTTON_SIZE}px;
`;

export const NextSlide = styled(Button)`
  right: 0px;
  margin-top: -${BUTTON_SIZE}px;
  border-bottom-left-radius: ${BUTTON_SIZE * 2}px;
  border-top-left-radius: ${BUTTON_SIZE * 2}px;
`;

export const PrevSlide = styled(Button)`
  left: 0px;
  margin-top: -${BUTTON_SIZE}px;
  border-bottom-right-radius: ${BUTTON_SIZE * 2}px;
  border-top-right-radius: ${BUTTON_SIZE * 2}px;
`;
